import { Maybe } from '@passionware/monads';
import React from 'react';
import { cn } from 'v5/platform/dom/cn';
import { WithServices } from 'v5/platform/ts/services';
import { WithGlobalSettingsService } from 'v5/services/internal/GlobalSettingsService/GlobalSettingsService';

export interface ResourceNameWithPronounsProps
  extends WithServices<[WithGlobalSettingsService]> {
  /** Primary name (string or node). */
  name: React.ReactNode;
  pronounsOptionId: Maybe<number>;
  resourceTypeId: Maybe<number>;
  className?: string;
  /** Additional classes for the name segment (e.g. font weight). */
  nameClassName?: string;
}

/**
 * Renders resource name with optional pronouns; keeps pronouns visible (no clip) when space is tight.
 */
export function ResourceNameWithPronouns({
  name,
  pronounsOptionId,
  resourceTypeId,
  services,
  className,
  nameClassName
}: ResourceNameWithPronounsProps) {
  const pronounsFromOptionId = services
    ? services.globalSettingsService.usePronounsForResourceType(
        pronounsOptionId ?? null,
        resourceTypeId ?? null
      )
    : null;

  const trimmed = pronounsFromOptionId?.trim();
  if (!trimmed) {
    return <span className={className}>{name}</span>;
  }

  return (
    <span
      className={cn(
        'inline-flex min-w-0 max-w-full flex-wrap items-baseline gap-y-0.5',
        className
      )}
    >
      <span className={cn('font-inherit', nameClassName)}>{name}</span>
      <span className="ml-1 shrink-0 text-sm text-fg-muted">{trimmed}</span>
    </span>
  );
}
